const EXTENSIONS: Record<string, string> = { jpeg: 'jpg', png: 'png', webp: 'webp' };

/** Hands the user a picture held as a data URL, named after what it shows. */
export function saveImage(dataUrl: string, baseName: string): void {
  const subtype = /^data:image\/([a-z]+)/i.exec(dataUrl)?.[1]?.toLowerCase() ?? 'png';
  const anchor = document.createElement('a');
  anchor.href = dataUrl;
  anchor.download = `${baseName}.${EXTENSIONS[subtype] ?? subtype}`;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}

/** "vase.stl" becomes "vase-render". */
export function renderName(fileName: string | undefined): string {
  const stem = fileName?.replace(/\.[^.]+$/, '').trim();
  return `${stem || 'model'}-render`;
}
